'use strict';

// Not SFRA 6x script upgrade compatible.Selective changes applied.

var states = require('storefront/util/states');
var util = require('improove/util/util');
import debounce from 'shared/js/util/debounce';

import siteConfig from 'shared/js/siteConfig';

/**
 * Open the level 2 menu and mark the active menu if we are in PLP.
 *
 * @returns {void}
 */
function openCurrentCategory() {
    var currentCategoryPath = document.querySelector('.js_current-category-path');
    if (currentCategoryPath && currentCategoryPath.dataset.currentCategoryPath !== 'null') {
        var path = JSON.parse(currentCategoryPath.dataset.currentCategoryPath);
        var selector = path.reduce((result, item) => {
            return (result && (result + ', ')) + '.menu-level-1-item[data-category-id="' + item + '"], .menu-level-2-item[data-category-id="' + item + '"]';
        }, '');
        var items = document.querySelectorAll(selector);
        for (let i = 0; i < items.length; i++) {
            items[i].classList.add('selected');
        }
        var notSelected = document.querySelectorAll('.menu-level-1-item:not(.selected), .menu-level-2-item:not(.selected)');
        for (let i = 0; i < notSelected.length; i++) {
            notSelected[i].classList.add('not-selected');
        }
    }
}

// Reset Menu Method
var resetMenu = function () {
    var containers = $('.menu-level-2-container, .menu-level-3-container');
    containers.each(function (i, el) {
        if ($(el).hasClass('menu-active-container')) {
            $(el).removeClass('menu-active-container');
        }
    });
    $('.menu-level-1-container').removeClass('level-2-active level-3-active');
    $('.menu-back-action').removeClass('show-button');
    $('.menu-level-1-item').unbind('mouseenter');
    $('.menu-level-1-item').unbind('mouseleave');
    $('.menu-level-3-item').unbind('click');
    if (!siteConfig.isSite('FM')) {
        $('.menu-level-1-item').unbind('click'); // #CDIFF #DONE FM does not have that line
    }
    $('.menu-level-2-item').unbind('click');
    $('.menu-back-action').unbind('click');
    $('.menu-parent-category').unbind('click');
    if (!siteConfig.isSite('FM', 'BS')) {
        $('.menu-parent-category-se').unbind('click'); // BS, FM don't have that line
    }
};

var menu = {};
menu.init = function init() {
    let menuTimeout = null;
    states.add('menu', $('.state-container--menu'), $('.menu-state-trigger'), {
        onActivate: function () {
            if (menuTimeout) {
                clearTimeout(menuTimeout);
                menuTimeout = null;
            }

            menuTimeout = setTimeout(function () {
                $('.menu-main-container').addClass('active');
                menuTimeout = null;
            }, 0);
        },
        onDeactivate: function () {
            if (menuTimeout) {
                clearTimeout(menuTimeout);
                menuTimeout = null;
            }
            menuTimeout = setTimeout(function () {
                $('.menu-main-container').removeClass('active');
                resetMenu();
                $('.header-hamburger-menu-icon').trigger('focus');
                menuTimeout = null;
            }, 0);
        }
    });

    function loadMenu() {
        resetMenu();
        if (util.getScreenSize() === 'small' || util.getScreenSize() === 'medium') {
            // Go to Sub menu level 2
            if ($('body').hasClass('state--menu')) {
                $('.menu-main-container').addClass('active');
            }

            $('.menu-level-1-item').on('click', function (e) {
                if ($(this).find('div').hasClass('menu-level-2-container')) {
                    e.preventDefault();
                    $('.menu-level-1-container').addClass('level-2-active');
                    $(this).find('.menu-level-2-container').addClass('menu-active-container');
                    $('.menu-back-action').addClass('show-button').trigger('focus');
                }
            });
            // Go to Sub menu Level 3
            $('.menu-level-2-item').on('click', function (e) {
                // Categories without subcategories render a desktop-only (.show-for-x-large) level 3 container
                var $level3Container = $(this).children('.menu-level-3-container').not('.show-for-x-large');
                if ($level3Container.length) {
                    e.preventDefault();
                    $('.menu-level-1-container').addClass('level-3-active');
                    $level3Container.addClass('menu-active-container');
                    $('#menu-state-container').scrollTop(0);
                } else {
                    e.stopPropagation();
                }
            });

            // Stop Propagation level 3 and for campaign pages in menu list
            $('.menu-level-3-item, .menu-content-list').on('click', function (e) {
                e.stopPropagation();
            });

            // Button go back on Sub menu
            $('.menu-back-action').on('click', function () {
                let level1c = $('.menu-level-1-container');
                if (level1c.hasClass('level-3-active')) {
                    level1c.removeClass('level-3-active');
                    $('.menu-level-3-container').removeClass('menu-active-container');
                } else if (level1c.hasClass('level-2-active')) {
                    level1c.removeClass('level-2-active');
                    $('.menu-level-2-container').removeClass('menu-active-container');
                    $('.menu-back-action').removeClass('show-button');
                    $('.close-state-trigger').trigger('focus');
                }
            });

            // #CDIFF #DONE GG, PF has line instead:
            var selectorMenuParentCategory;
            if (siteConfig.isSite('GG', 'PF')) {
                selectorMenuParentCategory = '.menu-parent-category, .menu-parent-category-se';
            } else {
                selectorMenuParentCategory = '.menu-parent-category';
            }
            $(selectorMenuParentCategory).on('click', function (event) {
                event.stopPropagation();
            });
        } else if (
            (siteConfig.isSite('BS', 'SN') && util.getScreenSize() === 'large')
            || (siteConfig.isSite('FM', 'GG', 'PF') && util.getScreenSize() !== 'small')
        ) { // #CDIFF #DONE FM, GG, PF have !== 'small' instead
            // Only for Desktop
            $('.menu-level-1-item')
                .on('mouseenter focusin', function () {
                    $('.menu-main-container').addClass('active');
                    // FM, GG, PF has $(this).addClass('active');
                    if (
                        $(this)
                            .find('div')
                            .hasClass('menu-level-2-container')
                    ) {
                        $('.menu-level-1-container').addClass('level-2-active');
                        $(this)
                            .find('.menu-level-2-container')
                            .addClass('menu-active-container');
                        $('body').addClass('no-scroll');
                    }
                })
                .on('mouseleave focusout', function () {
                    $('.menu-main-container').removeClass('active');
                    // FM, GG, PF has: $(this).removeClass('active');
                    $('.menu-level-1-container').removeClass('level-2-active');
                    $(this)
                        .find('.menu-level-2-container')
                        .removeClass('menu-active-container');
                    $('body').removeClass('no-scroll');
                });

            // Use arrows to move across main categories in menu on desktop
            $('.menu-level-1-item').on('keydown', function (e) {
                var el;
                if (e.code == 'ArrowRight' && $(this).next().length) {
                    el = $(this).next();
                    $(el).find('a').trigger('focus');
                } else if (e.code == 'ArrowRight' && !$(this).next().length) {
                    $('.menu-page-item:first-child a').trigger('focus');
                }

                if (e.code == 'ArrowLeft' && $(this).prev().length) {
                    el = $(this).prev();
                    $(el).find('a').trigger('focus');
                }
            });
        }
    }

    $(window).on(
        'resize',
        debounce(function () {
            loadMenu();
        }, 200)
    );

    $(document).ready(function () {
        $('.header-hamburger-menu-icon').on('click', function () {
            loadMenu();
            openCurrentCategory();
            setTimeout(function () {
                $('.close-state-trigger').trigger('focus');
            }, 50);
        });
    });

    loadMenu();
    openCurrentCategory();
};

module.exports = menu;
